export default {
  default: () => import("/builds/s-o-f/vkusilosos-frontend/layouts/default.vue").then(m => m.default || m)
}